<template>
<div>
    <v-toolbar flat color="white" pt-4 mt-4>
        <v-spacer></v-spacer>
      <v-text-field label="Search" v-model="search"></v-text-field>
        <v-btn round color="primary" @click="addSubmoduleModal=true">
            Add Submodule
        </v-btn>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="submodules"
        item-key="id"
        :rows-per-page-items="[25, 50, 100, 250]"
        :search="search"
        align-center
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
              <v-icon small @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
           <td class="text-xs-center">{{props.item.description}}</td>
           <td class="text-xs-center">{{props.item.routeFrontend.urlExtension}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

      <v-dialog v-model="addSubmoduleModal" max-width="750px">
          <v-card flat color="white">
              <v-toolbar color="primary"><h1 class="headline white--text">ADD SUBMODULE</h1></v-toolbar>
              <v-card-text>
                  <!-- <v-autocomplete
                  label="Associated Module"
                  v-model="item.moduleId"
                  :items="modules"
                  item-text="name"
                  item-value="id"
                  >
                  </v-autocomplete> -->
                  <v-autocomplete
                  label="Associated Frontend Route"
                  v-model="item.frontendRouteId"
                  :items="frontendRoutes"
                  item-text="name"
                  item-value="id"
                  >
                  </v-autocomplete>
                  <v-text-field label="Submodule Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
              </v-card-text>
              <v-card-actions>
                  <v-layout justify-center>
                      <v-btn round color="primary" @click="addSubmoduleModal=false">Cancel</v-btn>
                      <v-btn round color="primary" @click="saveSubmodule">Save</v-btn>
                  </v-layout>
              </v-card-actions>
          </v-card>
      </v-dialog>
       <v-dialog v-model="editModuleModal" max-width="750px">
        <v-card flat color="white">
          <v-toolbar color="primary"><h1 class="headline white--text">EDIT SUBMODULE: {{item.name}}</h1></v-toolbar>
          <v-card-text>
                  <!-- <v-autocomplete
                  label="Associated Module"
                  v-model="item.moduleId"
                  :items="modules"
                  item-text="name"
                  item-value="id"
                  >
                  </v-autocomplete> -->
                  <v-autocomplete
                  label="Associated Frontend Route"
                  v-model="item.routeFrontendId"
                  :items="frontendRoutes"
                  item-text="name"
                  item-value="id"
                  >
                  </v-autocomplete>
                  <v-text-field label="Submodule Name" v-model="item.name"></v-text-field>
                  <v-text-field label="Description" v-model="item.description"></v-text-field>
              </v-card-text>
          <v-card-actions>
          <v-layout justify-center>
            <v-btn round colour="gluePrimary" @click="editModuleModal=false">Cancel</v-btn>
            <v-btn round colour="gluePrimary" @click="saveEditedSubmodule">Save</v-btn>
          </v-layout>
        </v-card-actions>

        </v-card>
        

      </v-dialog>
</div>
  
</template>

<script>
import Api from "@/services/Api";
export default {
    data(){
        return {
            addSubmoduleModal:false,
            selected: [],
            item: {},
            modules: [],
            submodules: [],
            frontendRoutes:[],
            editModuleModal: false,
            search: '',
            headers: [
                {
          text: "Action",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Attached URL",
          align: "center",
          value: "routeFrontend.urlExtension"
        }
        ]
        }
    },
    created(){
        this.getModules();
        this.getSubmodules();
        this.getFrontendRoutes()
    },
    methods: {
        getFrontendRoutes(){
            Api()
            .get('/frontendRoute')
            .then(response=>{
                this.frontendRoutes=response.data
            })
        },
        getSubmodules(){
            Api()
            .get('/submodules')
            .then(response=>{
                this.submodules=response.data
            })
        },
        getModules(){
            Api()
            .get('/modules')
            .then(response=>{
                this.modules=response.data
            })
        },
        deleteItem(item){
            Api()
            .put('/submodules/'+item.id,{
                isActive: false,
                isDeleted: true
            }).then(this.getModules())
        },
        editItem(item){
            this.item = Object.assign({}, item);
            this.editModuleModal=true
        },
        saveSubmodule(){
            Api()
            .post('/submodules',{
                name: this.item.name,
                description: this.item.description,
                moduleId: this.item.moduleId,
                routeFrontendId: this.item.frontendRouteId,
                isActive: true,
                isDelete: false
            }).then(this.addSubmoduleModal=false, this.item={}, this.getSubmodules())
        },
        saveEditedSubmodule(){
            Api()
            .put('/submodules/'+this.item.id,{
                name: this.item.name,
                description: this.item.description,
                routeFrontendId: this.item.routeFrontendId,
                isActive: true,
                isDelete: false
            }).then(this.editModuleModal=false, this.item={}, this.getSubmodules())
        }
    }
}
</script>

<style>

</style>